import { AgreementData } from '@/types'
import { Network } from 'bitcoin-address-validation'
import { BitcoinNetworkType } from 'sats-connect'

export const BTC_NETWORK_TYPE = BitcoinNetworkType.Mainnet // For Xverse sats-connect library
export const BTC_NETWORK = Network.mainnet // For bitcoin-address-validation

export const IS_DEV = process.env.NODE_ENV === 'development'
export const IS_NOT_DEV = process.env.NODE_ENV !== 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'

export const LOCAL_STORAGE_LAST_CONNECTED_WALLET = 'last_connected_wallet'

// Superuser wallet address for admin panel access
export const SUPERUSER_WALLET_ADDRESS = 'bc1pt0vr7kjj6wntmknz6u00ta3z0znmjjv93swz7mj856fwgjgt3kjqfnpync'

// House wallet address for offboarding pass redemption
export const HOUSE_WALLET_ADDRESS = 'bc1pftjqw2pdc0gt2u9l2s87647gd02zv9qkrpg924f22dczxr2dpyjsesl7j8'

// Offboarding constants
export const TH_PER_PASS = 17
export const MAX_REDEMPTION_RATE_PER_TH = 5 // Maximum $/TH allowed

// Approved domains for transaction URLs
export const APPROVED_TRANSACTION_DOMAINS = [
  'solscan.io',
  'explorer.solana.com',
  'solana.fm',
]

/**
 * Validates redemption rate is within acceptable bounds
 * @returns error message if invalid, null if valid
 */
export const validateRedemptionRate = (rate: number | null | undefined): string | null => {
  if (rate === null || rate === undefined) return null
  const numRate = Number(rate)
  if (isNaN(numRate) || numRate <= 0 || numRate > MAX_REDEMPTION_RATE_PER_TH) {
    return `Redemption rate must be greater than 0 and at most ${MAX_REDEMPTION_RATE_PER_TH} ($/TH)`
  }
  return null
}

/**
 * Validates transaction URL is from an approved domain
 * @returns error message if invalid, null if valid
 */
export const validateTransactionUrl = (url: string): string | null => {
  try {
    const parsed = new URL(url)

    // Must be HTTPS
    if (parsed.protocol !== 'https:') {
      return 'Transaction URL must use HTTPS'
    }

    // Must be from approved domain
    const hostname = parsed.hostname.toLowerCase()
    const isApproved = APPROVED_TRANSACTION_DOMAINS.some(domain =>
      hostname === domain || hostname.endsWith(`.${domain}`)
    )

    if (!isApproved) {
      return `Transaction URL must be from an approved domain: ${APPROVED_TRANSACTION_DOMAINS.join(', ')}`
    }

    return null
  } catch {
    return 'Invalid transaction URL format'
  }
}

export enum CollectionEnum {
  fmp = 'fmp',
}

export const CollectionId = (collection: CollectionEnum) => {
  switch (collection) {
    case CollectionEnum.fmp:
      return 1
    default:
      throw new Error(`CollectionId not found for ${collection}`)
  }
}

export const AGREEMENT_DATA: AgreementData = {
  title: 'Membership Terms & Conditions',
  description:
    'Below is the membership agreement.  In order to use the site, you must agree to the terms and conditions.  Please read the agreement and sign your name below to indicate you agree to the terms and conditions.  You will sign this agreement with your private key indicating the owner of the wallet agrees to the terms and conditions.',
  link: 'https://docs.google.com/document/d/1qb2UtCed87VJ3UIg-WbjaVCUgAQUn7SG0_uRFztnGqU/edit',
  version: 1,
}

export const IDENFY = {
  authTokenUrl: 'https://ivs.idenfy.com/api/v2/token',
  webUIRedirectUrl: 'https://ivs.idenfy.com/api/v2/redirect?authToken=',
  apiKey: process.env.IDENFY_API_KEY,
  apiSecret: process.env.IDENFY_API_SECRET,
}

export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV

export const IDENFY_REDIRECT_URL =
  VERCEL_ENV === 'development'
    ? 'https://dashboard.ezmining.xyz'
    : VERCEL_ENV === 'production'
      ? `https://${process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}`
      : `https://${process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL}`

